<div class="container" [@fadeInOut]="state">
  <div class="title-container">
    <div class="order bg-primary">
      <p>#{{order}}</p>
    </div>
    <textarea
      #input
      placeholder="Agregar pregunta"
      (input)="getText(input.value, input)"
      (blur)="deleteTrim(input.value, input)"
      [(ngModel)]="lod_question"
      type="text"
    ></textarea>
    <div [style]="{ 'border-radius': '50%', width: '35px', height: '35px', 'margin-left': '4px' }">
      <p-button
        *ngIf="!first"
        (onClick)="deleteView()"
        icon="pi pi-trash"
        [rounded]="true"
        severity="danger"
        [style]="{ 'border-radius': '50%', width: '35px', height: '35px' }"
      ></p-button>
    </div>
  </div>
  <hr />
</div>
